import React, { useState, useEffect } from 'react';
import './test.css';
import ClearFilter from '../../components/ClearFilter';
import ExportTable from '../../components/ExportTable';
import { apiFetch } from '../../utils/api';

function Tests() {
  const [createCourseId, setCreateCourseId] = useState('');
  const [generateCourseId, setGenerateCourseId] = useState('');
  const [testNumber, setTestNumber] = useState('');
  const [testId, setTestId] = useState('');
  const [testIdError, setTestIdError] = useState('');
  const [createMessage, setCreateMessage] = useState('');
  const [courses, setCourses] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [testRequests, setTestRequests] = useState([]);
  const [isFetchingCourses, setIsFetchingCourses] = useState(true);
  const [isFetchingTestRequests, setIsFetchingTestRequests] = useState(true);
  const [isFetchingAssessments, setIsFetchingAssessments] = useState(true);
  const [currentPageRequests, setCurrentPageRequests] = useState(1);
  const [currentPageAssessments, setCurrentPageAssessments] = useState(1);
  const [itemsPerPageRequests, setItemsPerPageRequests] = useState(10);
  const [itemsPerPageAssessments, setItemsPerPageAssessments] = useState(10);
  const [searchCourseName, setSearchCourseName] = useState('');
  const [searchCourseId, setSearchCourseId] = useState('');
  const [searchUserName, setSearchUserName] = useState('');
  const [searchUserId, setSearchUserId] = useState('');
  const [searchCourseIdRequests, setSearchCourseIdRequests] = useState('');
  const [searchCourseNameRequests, setSearchCourseNameRequests] = useState('');
  const [searchTestNumber, setSearchTestNumber] = useState('');
  const [filterTestId1, setFilterTestId1] = useState(false);
  const [filterTestId2, setFilterTestId2] = useState(false);
  const [userId, setUserId] = useState('');
  const [userIdError, setUserIdError] = useState('');
  const [generateTestNumber, setGenerateTestNumber] = useState('');
  const [generateMessage, setGenerateMessage] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setIsFetchingCourses(true);
        const data = await apiFetch(`${window._env_.API_BASE_URL}/admintest/courses/`);
        setCourses(data);
      } catch (error) {
        console.error('Error fetching courses:', error);
      } finally {
        setIsFetchingCourses(false);
      }
    };
    const fetchTestRequests = async () => {
      try {
        setIsFetchingTestRequests(true);
        const data = await apiFetch(`${window._env_.API_BASE_URL}/admintest/pending-test-link-requests/`);
        setTestRequests(data.pending_requests);
      } catch (error) {
        console.error('Error fetching assessment requests:', error);
      } finally {
        setIsFetchingTestRequests(false);
      }
    };
    fetchCourses();
    fetchTestRequests();
  }, []);

  useEffect(() => {
    const fetchAssessments = async () => {
      try {
        setIsFetchingAssessments(true);
        const data = await apiFetch(`${window._env_.API_BASE_URL}/admintest/course-assessments/`);
        setAssessments(data);
      } catch (error) {
        console.error('Error fetching assessments:', error);
      } finally {
        setIsFetchingAssessments(false);
      }
    };
    fetchAssessments();
  }, [createMessage]);

  const validateTestId = (id) => {
    const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidPattern.test(id);
  };

  const validateUserId = (id) => {
    const num = parseInt(id, 10);
    return !isNaN(num) && num > 0;
  };

  const handleCreateTest = async (e) => {
    e.preventDefault();
    if (!validateTestId(testId)) {
      setCreateMessage('Assessment ID must be a valid UUID (e.g., a6cb19b2-7acb-4ff3-9b4b-76572900d73e)');
      return;
    }
    setCreateMessage('');
    setIsCreating(true);
    try {
      const payload = { course_id: parseInt(createCourseId), test_number: parseInt(testNumber), test_id: testId };
      const data = await apiFetch(`${window._env_.API_BASE_URL}/admintest/self-assessment/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      setCreateMessage(data.message || 'Assessment created successfully');
      setCreateCourseId('');
      setTestNumber('');
      setTestId('');
    } catch (error) {
      setCreateMessage(`Error creating Assessment: ${error.message}`);
    } finally {
      setIsCreating(false);
    }
  };

  const handleGenerateTestLink = async (e) => {
    e.preventDefault();
    if (!validateUserId(userId)) {
      setGenerateMessage('User ID must be a positive integer (greater than 0)');
      return;
    }
    setGenerateMessage('');
    setIsGenerating(true);
    try {
      const payload = { user_id: parseInt(userId), course_id: parseInt(generateCourseId), test_number: parseInt(generateTestNumber) };
      const data = await apiFetch(`${window._env_.API_BASE_URL}/admintest/attempt-specific-test/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      setGenerateMessage(`Assessment link generated successfully: ${data.test_link}`);
      setGenerateCourseId('');
      setUserId('');
      setGenerateTestNumber('');
    } catch (error) {
      setGenerateMessage(`Error generating Assessment link: ${error.message}`);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleMarkCompleted = async (userId, courseId, testNumber) => {
    try {
      await apiFetch(`${window._env_.API_BASE_URL}/admintest/mark-completed/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, course_id: courseId, test_number: testNumber }),
      });
      setTestRequests(testRequests.filter(req =>
        !(req.user_id === userId && req.course_id === courseId && req.test_number === testNumber)
      ));
    } catch (error) {
      console.error('Error marking as completed:', error);
    }
  };

  const handleClearTestRequestsFilters = () => {
    setSearchUserName('');
    setSearchUserId('');
    setSearchCourseIdRequests('');
    setSearchCourseNameRequests('');
    setSearchTestNumber('');
    setCurrentPageRequests(1);
  };

  const handleClearAssessmentsFilters = () => {
    setSearchCourseName('');
    setSearchCourseId('');
    setFilterTestId1(false);
    setFilterTestId2(false);
    setCurrentPageAssessments(1);
  };

  const filteredAssessments = assessments.filter((assessment) => {
    const matchesCourseName = assessment.coursename.toLowerCase().includes(searchCourseName.toLowerCase());
    const matchesCourseId = searchCourseId ? assessment.course_id.toString().includes(searchCourseId) : true;
    const matchesTestId1 = filterTestId1 ? assessment.testid1 : true;
    const matchesTestId2 = filterTestId2 ? assessment.testid2 : true;
    return matchesCourseName && matchesCourseId && matchesTestId1 && matchesTestId2;
  });

  const filteredTestRequests = testRequests.filter((request) => {
    const matchesUserName = request.user_email.toLowerCase().includes(searchUserName.toLowerCase());
    const matchesUserId = searchUserId ? request.user_id.toString().includes(searchUserId) : true;
    const matchesCourseId = searchCourseIdRequests ? request.course_id.toString().includes(searchCourseIdRequests) : true;
    const matchesCourseName = request.course_title.toLowerCase().includes(searchCourseNameRequests.toLowerCase());
    const matchesTestNumber = searchTestNumber ? request.test_number.toString().includes(searchTestNumber) : true;
    return matchesUserName && matchesUserId && matchesCourseId && matchesCourseName && matchesTestNumber;
  });

  const indexOfLastItemRequests = currentPageRequests * itemsPerPageRequests;
  const indexOfFirstItemRequests = indexOfLastItemRequests - itemsPerPageRequests;
  const currentTestRequests = filteredTestRequests.slice(indexOfFirstItemRequests, indexOfLastItemRequests);
  const totalPagesRequests = Math.ceil(filteredTestRequests.length / itemsPerPageRequests);

  const indexOfLastItemAssessments = currentPageAssessments * itemsPerPageAssessments;
  const indexOfFirstItemAssessments = indexOfLastItemAssessments - itemsPerPageAssessments;
  const currentAssessments = filteredAssessments.slice(indexOfFirstItemAssessments, indexOfLastItemAssessments);
  const totalPagesAssessments = Math.ceil(filteredAssessments.length / itemsPerPageAssessments);

  const paginateRequests = (pageNumber) => setCurrentPageRequests(pageNumber);
  const paginateAssessments = (pageNumber) => setCurrentPageAssessments(pageNumber);

  const getPageNumbers = (totalPages, currentPage) => {
    const pageNumbers = [];
    const maxPageButtons = 3;
    for (let i = Math.max(1, currentPage - 1); i <= Math.min(totalPages, currentPage + 1); i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const handleItemsPerPageRequestsChange = (e) => {
    setItemsPerPageRequests(parseInt(e.target.value));
    setCurrentPageRequests(1);
  };

  const handleItemsPerPageAssessmentsChange = (e) => {
    setItemsPerPageAssessments(parseInt(e.target.value));
    setCurrentPageAssessments(1);
  };

  return (
    <div className="tests">
      <h2>Assessments Content</h2>
      <section className="create-test">
        <h3>Create New Assessment</h3>
        <form onSubmit={handleCreateTest}>
          <select value={createCourseId} onChange={(e) => setCreateCourseId(e.target.value)} required>
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course.course_id} value={course.course_id}>
                {course.course_id} - {course.title}
              </option>
            ))}
          </select>
          <select value={testNumber} onChange={(e) => setTestNumber(e.target.value)} required>
            <option value="">Assessment Number</option>
            <option value="1">Assessment 1</option>
            <option value="2">Assessment 2</option>
          </select>
          <input
            type="text"
            value={testId}
            onChange={(e) => setTestId(e.target.value)}
            placeholder="Enter Assessment ID"
            required
          />
          <button
            type="submit"
            disabled={isCreating}
            className={isCreating ? 'disabled-btn' : ''}
          >
            {isCreating ? 'CREATING' : 'CREATE ASSESSMENT'}
          </button>
        </form>
        {(createMessage) && (
          <p
            className={createMessage.includes('Error') || createMessage.includes('must be')
              ? 'error-message'
              : 'success-message'}
          >
            {createMessage}
          </p>
        )}
      </section>

      <section className="create-test">
        <h3>Generate Assessment Link For User</h3>
        <form onSubmit={handleGenerateTestLink}>
          <select value={generateCourseId} onChange={(e) => setGenerateCourseId(e.target.value)} required>
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course.course_id} value={course.course_id}>
                {course.course_id}-{course.title}
              </option>
            ))}
          </select>
          <input
            type="number"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder="Enter User ID"
            min="1"
            required
          />
          <select value={generateTestNumber} onChange={(e) => setGenerateTestNumber(e.target.value)} required>
            <option value="">Assessment Number</option>
            <option value="1">Assessment 1</option>
            <option value="2">Assessment 2</option>
          </select>
          <button
            type="submit"
            disabled={isGenerating}
            className={isGenerating ? 'disabled-btn' : ''}
          >
            {isGenerating ? 'GENERATING' : 'GENERATE ASSESSMENT LINK'}
          </button>
        </form>
        {(generateMessage || userIdError) && (
          <p
            className={(generateMessage.includes('Error') || userIdError || generateMessage.includes('must be'))
              ? 'error-message'
              : 'success-message'}
          >
            {generateMessage || userIdError}
          </p>
        )}
      </section>
      <br /><br />
      <section className="test-request-table">
        <h3>Assessment Request Notifications</h3>
        <div className="filters">
          <input
            type="text"
            value={searchUserName}
            onChange={(e) => setSearchUserName(e.target.value)}
            placeholder="Search by User Email"
          />
          <input
            type="text"
            value={searchUserId}
            onChange={(e) => setSearchUserId(e.target.value)}
            placeholder="Search by User ID"
          />
          <input
            type="text"
            value={searchCourseIdRequests}
            onChange={(e) => setSearchCourseIdRequests(e.target.value)}
            placeholder="Search by Course ID"
          />
          <input
            type="text"
            value={searchCourseNameRequests}
            onChange={(e) => setSearchCourseNameRequests(e.target.value)}
            placeholder="Search by Course Name"
          />
          <select
            value={searchTestNumber}
            onChange={(e) => setSearchTestNumber(e.target.value)}
          >
            <option value="">All Assessment Numbers</option>
            <option value="1">Assessment 1</option>
            <option value="2">Assessment 2</option>
          </select>
          <ClearFilter onClear={handleClearTestRequestsFilters} />
          <ExportTable
            data={filteredTestRequests}
            headers={['USER ID', 'USER EMAIL', 'COURSE ID', 'COURSE NAME', 'ASSESSMENT NUMBER', 'COMPLETED']}
            tableName="Assessment_Request_Notifications"
          />
        </div>
        <table>
          <thead>
            <tr>
              <th>User ID</th>
              <th>User Email</th>
              <th>Course ID</th>
              <th>Course Name</th>
              <th>Assessment Number</th>
              <th>Completed</th>
            </tr>
          </thead>
          <tbody>
            {isFetchingTestRequests ? (
              <tr>
                <td colSpan="6" style={{ color: 'black', textAlign: 'center' }}>
                  Loading...
                </td>
              </tr>
            ) : currentTestRequests.length > 0 ? (
              currentTestRequests.map((request) => (
                <tr key={`${request.user_id}-${request.course_id}-${request.test_number}`}>
                  <td>{request.user_id}</td>
                  <td>{request.user_email}</td>
                  <td>{request.course_id}</td>
                  <td>{request.course_title}</td>
                  <td>{request.test_number}</td>
                  <td>
                    <button
                      className="mark-completed-btn"
                      onClick={() => handleMarkCompleted(request.user_id, request.course_id, request.test_number)}
                    >
                      Mark as Completed
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ color: 'red', textAlign: 'center' }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="pagination">
          <button
            onClick={() => paginateRequests(currentPageRequests - 1)}
            disabled={currentPageRequests === 1}
            className="pagination-btn"
          >
            Prev
          </button>
          {getPageNumbers(totalPagesRequests, currentPageRequests).map((number) => (
            <button
              key={number}
              onClick={() => paginateRequests(number)}
              className={`pagination-btn ${currentPageRequests === number ? 'active' : ''}`}
            >
              {number}
            </button>
          ))}
          <button
            onClick={() => paginateRequests(currentPageRequests + 1)}
            disabled={currentPageRequests === totalPagesRequests}
            className="pagination-btn"
          >
            Next
          </button>
          <select
            value={itemsPerPageRequests}
            onChange={handleItemsPerPageRequestsChange}
            className="items-per-page"
          >
            {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((value) => (
              <option key={value} value={value}>{value}</option>
            ))}
          </select>
          <span className="pagination-info">
            Showing {indexOfFirstItemRequests + 1} to {Math.min(indexOfLastItemRequests, filteredTestRequests.length)} of {filteredTestRequests.length}
          </span>
        </div>
      </section>
      <br /><br />
      <section className="assessment-table">
        <h3>Course Assessments</h3>
        <div className="filters">
          <input
            type="text"
            value={searchCourseName}
            onChange={(e) => setSearchCourseName(e.target.value)}
            placeholder="Search by Course Name"
          />
          <input
            type="text"
            value={searchCourseId}
            onChange={(e) => setSearchCourseId(e.target.value)}
            placeholder="Search by Course ID"
          />
          <div className="test-id-filters">
            <label>
              <input
                type="checkbox"
                checked={filterTestId1}
                onChange={(e) => setFilterTestId1(e.target.checked)}
              />
              Has Assessment ID 1
            </label>
            <label>
              <input
                type="checkbox"
                checked={filterTestId2}
                onChange={(e) => setFilterTestId2(e.target.checked)}
              />
              Has Assessment ID 2
            </label>
          </div>
          <ClearFilter onClear={handleClearAssessmentsFilters} />
          <ExportTable
            data={filteredAssessments}
            headers={['COURSE ID', 'COURSE NAME', 'ASSESSMENT ID 1', 'ASSESSMENT ID 2']}
            tableName="Course_Assessments"
          />
        </div>
        <table>
          <thead>
            <tr>
              <th>Course ID</th>
              <th>Course Name</th>
              <th>Assessment ID 1</th>
              <th>Assessment ID 2</th>
            </tr>
          </thead>
          <tbody>
            {isFetchingAssessments ? (
              <tr>
                <td colSpan="4" style={{ color: 'black', textAlign: 'center' }}>
                  Loading...
                </td>
              </tr>
            ) : currentAssessments.length > 0 ? (
              currentAssessments.map((assessment) => (
                <tr key={assessment.course_id}>
                  <td>{assessment.course_id}</td>
                  <td>{assessment.coursename}</td>
                  <td>{assessment.testid1 || 'No Assessment'}</td>
                  <td>{assessment.testid2 || 'No Assessment'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ color: 'red', textAlign: 'center' }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="pagination">
          <button
            onClick={() => paginateAssessments(currentPageAssessments - 1)}
            disabled={currentPageAssessments === 1}
            className="pagination-btn"
          >
            Prev
          </button>
          {getPageNumbers(totalPagesAssessments, currentPageAssessments).map((number) => (
            <button
              key={number}
              onClick={() => paginateAssessments(number)}
              className={`pagination-btn ${currentPageAssessments === number ? 'active' : ''}`}
            >
              {number}
            </button>
          ))}
          <button
            onClick={() => paginateAssessments(currentPageAssessments + 1)}
            disabled={currentPageAssessments === totalPagesAssessments}
            className="pagination-btn"
          >
            Next
          </button>
          <select
            value={itemsPerPageAssessments}
            onChange={handleItemsPerPageAssessmentsChange}
            className="items-per-page"
          >
            {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((value) => (
              <option key={value} value={value}>{value}</option>
            ))}
          </select>
          <span className="pagination-info">
            Showing {indexOfFirstItemAssessments + 1} to {Math.min(indexOfLastItemAssessments, filteredAssessments.length)} of {filteredAssessments.length}
          </span>
        </div>
      </section>
    </div>
  );
}

export default Tests;